class Apiendpoints {
    constructor() {
      this.SEND_CONTACT_QUERY = process.env.REACT_APP_API_BASE_URL + "contact";
    }
  }
  
  export default Apiendpoints;

